import StatSpy from './stat-spy.js';

import utils from './stat-utils.js';
// Default options for the plugin.
const DEFAULTS = {
	method: "GET",
	contentType: 'form',
	urlPlaceholders: []
};

/**
 * The Stat class to send stat via XHR or using image tag.
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends StatSpy
 */

class StatXHR extends StatSpy {
	constructor(player, options) {
		let options_ = Object.assign({}, DEFAULTS, options);
		super(player, options_);

		this.url = options_.url;
		this.method = options_.method;
		this.data = options_.data;
		this.cache = options_.cache;
		this.urlPlaceholders = options_.urlPlaceholders;
		this.contentType = options_.contentType;
		this.withCredentials = options_.withCredentials;
		this.xhrCallback = options_.xhrCallback || function() {};
	}

	send(ev, data) {
		var url = this.getUrl(ev);

		if (!url) return;
		super.send(ev);

		if (this.utils.isPromise(url)) {
			url.then((url) => {
				this.makeReq(this.replaceUrlPlaceholders(url, ev), ev, data);
			});
		} else {
			this.makeReq(this.replaceUrlPlaceholders(url, ev), ev, data);
		}
	}

	replaceUrlPlaceholders(url, ev) {
		var res = url;

		this.urlPlaceholders.forEach((item) => {
			let val = this.utils.processVal.call(this, item.value, ev);
			res = this.utils.replaceAll(res, item.name, val);
		});

		return res;
	}

	makeReq(url, ev, data) {
		var payload = this.getData(ev, data);
		if (payload && payload.wcr_special && payload.wcr_special.ignore) {
			return;
		}
		if (payload) {
			delete payload.wcr_special;
		}
		if (!payload) {
			return;
		}

		if (this.method == 'image') {
			this.utils.image(url, {cache: this.cache, payload});
		} else {
			this.utils.xhr(url, {method: this.method, data: payload, contentType: this.contentType, withCredentials: this.withCredentials}, this.xhrCallback.bind(this));
		}
	}

	getData(ev, data) {
		return this.utils.proceedData(this.data, this, { event: ev, data: data });
	}

	getUrl(ev) {
		return this.utils.processVal.call(this, this.url, ev);
	}
}

export default StatXHR;
